import {Outlet} from "react-router-dom";
import {Stack} from "@mantine/core";
import React from "react";

export default function Tables() {

    return (
        <Stack>
            {/*<Navigate to={'access-codes'}/>*/}
            <Outlet/>
        </Stack>
    )
}
